export enum EstadoEnum{
    PreAsiento = 'ESPREASIE',
    AutorizadoAsiento = 'ESAUTORIZA',
    RechazadoAutorizanteAsiento = 'ESRECHAAUT',
    CargadoCompraVenta = 'ESCOVECAR',
    AutorizadoCompraVenta = 'ESCOVEAUT',
    EnCarga = 'ESCARDOC',
    EnviadoAFogapy = 'ESENVIFOG',
    EnviadoAIfp = 'ESENVIIFP',
    DocumentacionVerificada = 'ESVERIFDOC',
    EstadoDocumentacionAprobada = 'ESAPROB',
    EstadoDocumentacionRechazada = 'ESRECHAZ',
}